import type {AppError, ErrorService} from '@/domain/interfaces/ErrorService';

export class ErrorServiceImpl implements ErrorService {
  private subscribers: Array<(error: AppError) => void> = [];

  publish = (error: AppError) => {
    this.subscribers.forEach((callback) => {
      callback(error);
    });
  };

  subscribe = (onError: (error: AppError) => void) => {
    this.subscribers.push(onError);
    return () => {
      this.subscribers = this.subscribers.filter((cb) => cb !== onError);
    };
  };
}
